import { useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  DateRangeParams,
  ResellerStatisticsResponse
} from '@utils/types/resellers/dashboard.ts';

export const useGetResellerStatistics = (dateRange?: DateRangeParams) => {
  const fetchResellerStatistics = async () => {
    const endpoint = GET_URL(
      dateRange?.periodStart || '',
      dateRange?.periodEnd || ''
    ).resellerStatistics;

    if (!endpoint) {
      throw new Error('Reseller statistics endpoint not configured');
    }

    const { data } = await Axios.get<ResellerStatisticsResponse>(endpoint);
    return data;
  };

  return useQuery<ResellerStatisticsResponse, AxiosError<BaseError>>(
    ['resellerStatistics', dateRange?.periodStart, dateRange?.periodEnd],
    fetchResellerStatistics,
    {
      keepPreviousData: true, // Keep showing old data while fetching new
      retry: false,
      staleTime: 0, // Always fetch fresh data when query key changes
      refetchOnMount: false,
      enabled: true // Always enabled, will refetch when query key changes
    }
  );
};
